import { render, staticRenderFns } from "./Mostgames.vue?vue&type=template&id=6085fda8"
import script from "./Mostgames.vue?vue&type=script&lang=js"
export * from "./Mostgames.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports